"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var guid = require("guid");
/**
 *
 * This class is used for initializing an application session and maintaining old Session IDs.
 *
 * We should always retain the old session IDs in an array in LocalStorage and limit the array to a certain size
 * (to avoid exhausting the LocalStorage limit). Why? Because we want to log messages before a user is even
 * authenticated, these logs would contain a session ID. In case of any issue with web client before the user could be
 * authenticated, we can ask the user to send their old session IDs for us to do a log dive.
 *
 * Just in case we need to log dive into a previous pre-login issue, the previous IDs (using getSessionIdsFromStorage
 * method) should be emitted after every successful login
 *
 * @author sainara
 */
var AppSession = (function () {
    function AppSession(context, storageKey) {
        this.context = context;
        this.storageKey = storageKey;
        this._currentSessionid = guid.raw();
        this.storage = context.localStorage;
        this.storeCurrentSessionIdToStorage();
    }
    Object.defineProperty(AppSession.prototype, "currentSessionId", {
        get: function () {
            return this._currentSessionid;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns an array of previous session IDs. The idea is that we will emit these session IDs to log service
     * as soon as we've authenticated the user.
     */
    AppSession.prototype.getSessionIdsFromStorage = function () {
        var prevSessionIdsStr = this.storage.getItem(this.storageKey);
        var prevSessionIds = [];
        if (prevSessionIdsStr) {
            try {
                prevSessionIds = JSON.parse(prevSessionIdsStr);
            }
            catch (e) {
                console.error("Error occurred while parsing the value of " + this.storageKey);
            }
        }
        return prevSessionIds;
    };
    AppSession.prototype.storeCurrentSessionIdToStorage = function () {
        var allSessionIds = [this._currentSessionid].concat(this.getSessionIdsFromStorage());
        allSessionIds.length = 5; // store only to a max for 5
        this.storage.setItem(this.storageKey, JSON.stringify(allSessionIds));
    };
    return AppSession;
}());
exports.AppSession = AppSession;
